export default __webpack_public_path__ + "static/media/stockUser.a9136072.png";